import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { FullComponent } from './layouts/full/full.component';
import { BlankComponent } from './layouts/blank/blank.component';

export const Approutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      // { path: '', redirectTo: '/dashboard/classic', pathMatch: 'full' },
      { path: '', redirectTo: 'authentication/login2', pathMatch: 'full' },

      {
        path: 'dashboard',
        loadChildren: './dashboards/dashboard.module#DashboardModule'
      },

     
     
     
    
     
      {
        path: 'customer',
        loadChildren: './customer/customer.module#CustomerModule'
      },
      
      {
        path: 'payment',
        loadChildren: './payment/payment.module#PaymentModule'
      },
      {
        path: 'ps',
        loadChildren: './ps/ps.module#PsModule'
      },
      {
        path: 'order',
        loadChildren: './order/order.module#Ordermodule'
      },
      {
        path: 'extra-component',
        loadChildren:
          './extra-component/extra-component.module#ExtraComponentModule'
      },
      //Added by abubakkar on 03/11/2023
      {
        path: 'user-management',
        loadChildren:
          './user-management/user-management.module#UserManagementmodule'
      },
      {
        path: 'purchase',
        loadChildren: './purchase/purchase.module#PurchaseModule'
      },
      {
        path: 'reports',
        loadChildren: './reports/reports.module#ReportsModule'
      },
      
      
      // {
      //   path: 'invoice',
      //   loadChildren: './invoice/invoice.module#InvoiceModule'
      // },
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren:
          './authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  {
    path: '**',
    redirectTo: '/authentication/404'
  }
];
